import { FormTextCollection } from './FormTextCollection'

export const FormTextCollectionPdfEditor = props => {
  return <FormTextCollection editor {...props} />
}
